import { render, staticRenderFns } from "./Editorials.vue?vue&type=template&id=3fbc4a6c&scoped=true"
import script from "./Editorials.vue?vue&type=script&lang=js"
export * from "./Editorials.vue?vue&type=script&lang=js"
import style0 from "./Editorials.vue?vue&type=style&index=0&id=3fbc4a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbc4a6c",
  null
  
)

export default component.exports